import script from "./GetInTouchForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GetInTouchForm.vue?vue&type=script&setup=true&lang=js"

import "./GetInTouchForm.vue?vue&type=style&index=0&id=5a3f4927&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a3f4927"]])

export default __exports__